export function arrowScrollBottom() {
    const button = $(".scroll-next-section button");

    button.click(function () {
        const heroSection = $(this).closest(".hero-section").innerHeight();

        $("body, html").animate({scrollTop: heroSection}, 700);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/arrowScrollBottom.js